(ns common.transaction-process.templates.capman.other
  (:require
   [common.transaction-process.templates.capman.common :as common]))

(def template-id :transaction-process-template/capman-other)

(def template
  (common/build-template
   {:template-id            template-id
    :template-name          "Generic"
    :strategy-fields        []
    :strategy-field-configs {}}))
